import ReflexivePronounsFormalDeckIMG from "../../assets/DeckCards/Pronouns/ReflexivePronounsFormalDeckIMG.png";
import ReflexivePronounsInformalDeckIMG from "../../assets/DeckCards/Pronouns/ReflexivePronounsInformalDeckIMG.png";
import DemonstrativePronounsFormalDeckIMG from "../../assets/DeckCards/Pronouns/DemonstrativePronounsFormalDeckIMG.png";
import DemonstrativePronounsInformalDeckIMG from "../../assets/DeckCards/Pronouns/DemonstrativePronounsInformalDeckIMG.png";
import InterrogativePronounsFormalDeckIMG from "../../assets/DeckCards/Pronouns/InterrogativePronounsFormalDeckIMG.png";
import InterrogativePronounsInformalDeckIMG from "../../assets/DeckCards/Pronouns/InterrogativePronounsInformalDeckIMG.png";
import IndefinitePronounsFormalDeckIMG from "../../assets/DeckCards/Pronouns/IndefinitePronounsFormalDeckIMG.png";
import IndefinitePronounsInformalDeckIMG from "../../assets/DeckCards/Pronouns/IndefinitePronounsInformalDeckIMG.png";
import SubjectPronounsFormalDeckIMG from "../../assets/DeckCards/Pronouns/SubjectPronounsFormalDeckIMG.png";
import SubjectPronounsInformalDeckIMG from "../../assets/DeckCards/Pronouns/SubjectPronounsInformalDeckIMG.png";
import ObjectPronounsFormalDeckIMG from "../../assets/DeckCards/Pronouns/ObjectPronounsFormalDeckIMG.png";
import ObjectPronounsInformalDeckIMG from "../../assets/DeckCards/Pronouns/ObjectPronounsInformalDeckIMG.png";
import PossessivePronounsFormalDeckIMG from "../../assets/DeckCards/Pronouns/PossessivePronounsFormalDeckIMG.png";
import PossessivePronounsInformalDeckIMG from "../../assets/DeckCards/Pronouns/PossessivePronounsInformalDeckIMG.png";

export const PronounsDeckFace = [
    {
        id: "reflexive-pronouns-formal",
        Title: "Reflexive Pronouns (Formal)",
        Description: "Learn how to use reflexive pronouns!",
        Difficulty: "Beginner 2",
        Image: ReflexivePronounsFormalDeckIMG,
        Link: "/ReflexivePronounsFormalDeck",
        cssId: "reflexive-pronouns-formal-ID"
    },
    {
        id: "reflexive-pronouns-informal",
        Title: "Reflexive Pronouns (Informal)",
        Description: "Learn how to use reflexive pronouns in informal speech!",
        Difficulty: "Beginner 2",
        Image: ReflexivePronounsInformalDeckIMG,
        Link: "/ReflexivePronounsInformalDeck",
        cssId: "reflexive-pronouns-informal-ID"
    },
    {
        id: "demonstrative-pronouns-formal",
        Title: "Demonstrative Pronouns (Formal)",
        Description: "Master formal demonstrative pronouns!",
        Difficulty: "Beginner 2",
        Image: DemonstrativePronounsFormalDeckIMG,
        Link: "/DemonstrativePronounsFormalDeck",
        cssId: "demonstrative-pronouns-formal-ID"
    },
    {
        id: "demonstrative-pronouns-informal",
        Title: "Demonstrative Pronouns (Informal)",
        Description: "Master informal demonstrative pronouns!",
        Difficulty: "Beginner 2",
        Image: DemonstrativePronounsInformalDeckIMG,
        Link: "/DemonstrativePronounsInformalDeck",
        cssId: "demonstrative-pronouns-informal-ID"
    },
    {
        id: "interrogative-pronouns-formal",
        Title: "Interrogative Pronouns (Formal)",
        Description: "Learn how to ask questions politely!",
        Difficulty: "Beginner 2",
        Image: InterrogativePronounsFormalDeckIMG,
        Link: "/InterrogativePronounsFormalDeck",
        cssId: "interrogative-pronouns-formal-ID"
    },
    {
        id: "interrogative-pronouns-informal",
        Title: "Interrogative Pronouns (Informal)",
        Description: "Learn how to ask questions informally!",
        Difficulty: "Beginner 2",
        Image: InterrogativePronounsInformalDeckIMG,
        Link: "/InterrogativePronounsInformalDeck",
        cssId: "interrogative-pronouns-informal-ID"
    },
    {
        id: "indefinite-pronouns-formal",
        Title: "Indefinite Pronouns (Formal)",
        Description: "Use indefinite pronouns in polite contexts!",
        Difficulty: "Beginner 2",
        Image: IndefinitePronounsFormalDeckIMG,
        Link: "/IndefinitePronounsFormalDeck",
        cssId: "indefinite-pronouns-formal-ID"
    },
    {
        id: "indefinite-pronouns-informal",
        Title: "Indefinite Pronouns (Informal)",
        Description: "Use indefinite pronouns in casual contexts!",
        Difficulty: "Beginner 2",
        Image: IndefinitePronounsInformalDeckIMG,
        Link: "/IndefinitePronounsInformalDeck",
        cssId: "indefinite-pronouns-informal-ID"
    },
    {
        id: "subject-pronouns-formal",
        Title: "Subject Pronouns (Formal)",
        Description: "Learn subject pronouns for formal speech!",
        Difficulty: "Beginner 2",
        Image: SubjectPronounsFormalDeckIMG,
        Link: "/SubjectPronounsFormalDeck",
        cssId: "subject-pronouns-formal-ID"
    },
    {
        id: "subject-pronouns-informal",
        Title: "Subject Pronouns (Informal)",
        Description: "Learn subject pronouns for casual speech!",
        Difficulty: "Beginner 2",
        Image: SubjectPronounsInformalDeckIMG,
        Link: "/SubjectPronounsInformalDeck",
        cssId: "subject-pronouns-informal-ID"
    },
    {
        id: "object-pronouns-formal",
        Title: "Object Pronouns (Formal)",
        Description: "Understand object pronouns in formal contexts!",
        Difficulty: "Beginner 2",
        Image: ObjectPronounsFormalDeckIMG,
        Link: "/ObjectPronounsFormalDeck",
        cssId: "object-pronouns-formal-ID"
    },
    {
        id: "object-pronouns-informal",
        Title: "Object Pronouns (Informal)",
        Description: "Understand object pronouns in casual contexts!",
        Difficulty: "Beginner 2",
        Image: ObjectPronounsInformalDeckIMG,
        Link: "/ObjectPronounsInformalDeck",
        cssId: "object-pronouns-informal-ID"
    },
    {
        id: "possessive-pronouns-formal",
        Title: "Possessive Pronouns (Formal)",
        Description: "Learn how to express possession politely!",
        Difficulty: "Beginner 2",
        Image: PossessivePronounsFormalDeckIMG,
        Link: "/PossessivePronounsFormalDeck",
        cssId: "possessive-pronouns-formal-ID"
    },
    {
        id: "possessive-pronouns-informal",
        Title: "Possessive Pronouns (Informal)",
        Description: "Learn how to express possession casually!",
        Difficulty: "Beginner 2",
        Image: PossessivePronounsInformalDeckIMG,
        Link: "/PossessivePronounsInformalDeck",
        cssId: "possessive-pronouns-informal-ID"
    }
];
